<template>
<header>
     <h1>Dragon Conqueror</h1>
</header>

</template>

<script>
    export default{
        name: 'TheHeader'
    }
</script>

<style scoped>
    header{
        background: #370617;
        color: #fff;
        padding: .5rem;
        text-align: center;
    }
    h1{
        font-size: 2rem;
        font-weight: 600;
    }
</style>